import { NgModule } from '@angular/core';
import { SharedModule } from '../../modules/shared.module';

import { ComfirmComponent } from './confirm.component';
import { ConfirmService } from './confirm.service';

@NgModule({
  imports: [SharedModule
  ],
  exports: [ComfirmComponent],
  declarations: [ComfirmComponent],
  providers: [ConfirmService],
  // entryComponents: [ComfirmComponent]
})
export class ConfirmModule { }



// WEBPACK FOOTER //
// ./src/app/core/components/confirm/confirm.module.ts